import { useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareModal({ open, onClose, title }: Props) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const link = window.location.href;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-md bg-background-50 rounded-lg p-6 md:p-7 border border-background-200/70">
        <button
          onClick={onClose}
          aria-label="关闭"
          className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-foreground-500 hover:bg-background-100 hover:text-foreground-900 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
        <h3 className="font-heading text-lg font-bold text-foreground-950">分享《{title}》</h3>
        <p className="mt-1.5 text-sm text-foreground-500">把这部作品推荐给同样爱看影视的朋友吧。</p>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {[
            { icon: "ri-weibo-fill", label: "微博" },
            { icon: "ri-wechat-fill", label: "微信" },
            { icon: "ri-link-m", label: "复制链接" },
            { icon: "ri-more-2-fill", label: "更多" },
          ].map((item) => (
            <button
              key={item.label}
              onClick={item.label === "复制链接" ? copyLink : copyLink}
              className="flex flex-col items-center gap-2 py-3 rounded-lg bg-background-100 hover:bg-primary-100 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 rounded-full bg-background-50 flex items-center justify-center text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 px-3 py-2.5 rounded-md bg-background-100 border border-background-200/70">
          <i className="ri-links-line text-foreground-400"></i>
          <span className="flex-1 text-xs text-foreground-600 truncate">{link}</span>
          <button
            onClick={copyLink}
            className="text-xs text-primary-600 font-medium whitespace-nowrap hover:text-primary-700 cursor-pointer"
          >
            {copied ? "已复制" : "复制"}
          </button>
        </div>

        <p className="mt-4 text-xs text-foreground-400 leading-relaxed">
          提示：以上分享方式为演示效果，正式分享请通过对应平台客户端操作。
        </p>
      </div>
    </div>
  );
}